import SearchIcon from '@mui/icons-material/Search';
import { Chip, Grid, IconButton, InputAdornment, TextField, Tooltip } from '@mui/material';
import React from 'react';

import { debounce } from '../utils';

export const UserListToolbar = (props) => {
    const searchQueryRef = React.useRef(null);
    // const roleMapKeys = Object.keys(roleMap);
    // const theme = useTheme();
    // const isXLargeScreen = useIsWidthUp('xl');

    const handleSearchQueryChange = (ev) => {
        debouncedSearchQueryChangeHandler.cancel();
        doSearch(searchQueryRef.current?.value);
    };

    const debouncedSearchQueryChangeHandler = debounce(handleSearchQueryChange, 300);

    const doSearch = (query) => props.onQueryChange && props.onQueryChange(query);



    return (
        <Grid item xs={12} container direction="row" alignItems="center">
            <Grid item xs={12} sm={6} lg={4} p={props.isSmallScreen ? 0 : 2}  >
                <TextField
                    variant="filled"
                    label="Search"
                    size="small"
                    defaultValue={props.query}
                    onChange={debouncedSearchQueryChangeHandler}
                    inputRef={searchQueryRef}
                    fullWidth
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <Tooltip title="Search">
                                    <IconButton aria-label="do search" onClick={handleSearchQueryChange}>
                                        <SearchIcon />
                                    </IconButton>
                                </Tooltip>
                            </InputAdornment>
                        ),
                    }}
                />

            </Grid>
            {props.isGuest && (
                <Grid item xs="auto" p={props.isSmallScreen ? 0 : 1} sx={props.isSmallScreen ? { mt: 2 } : undefined}>
                    <Chip
                        label="Has Active/Future Booking"
                        clickable
                        color={props.hasActiveFutureBooking ? 'primary' : 'default'}
                        variant={props.hasActiveFutureBooking ? 'filled' : 'outlined'}
                        onClick={() => props.setHasActiveFutureBooking && props.setHasActiveFutureBooking(v => !v)}
                        size="small"
                    />
                </Grid>
            )}
            {/* Export lives in the page header beside [+ New user] (CP-8291);
                UserListTab portals it there. */}
            {/* {props.currentTab === 1 && (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        xl={8}
                        mt={props.isSmallScreen ? 2 : 0}
                        className={props.isSmallScreen && 'hide-scrollbar'}
                        style={{ display: 'flex', flexWrap: 'nowrap', justifyContent: !isXLargeScreen ? 'space-between' : 'flex-end', gap: '0.5rem', overflow: 'auto', maxWidth: '95vw', alignItems: 'center' }}
                    >
                        <Grid
                            item
                            xs={'auto'}
                            style={{
                                padding: '6px 20px',
                                borderRadius: '20px',
                                backgroundColor: !props.recordListRoleFilters || props.recordListRoleFilters.length === 0 ? theme.palette.primary.main : '#D8D8D8',
                                color: !props.recordListRoleFilters || props.recordListRoleFilters.length === 0 ? 'white' : 'rgba(0, 0, 0, 0.87)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                border: 'solid 1px lightgrey',
                            }}
                            key={null}
                            onClick={() => handleRoleFilterSelect(null)}
                        >
                            <Typography>All</Typography>
                        </Grid>
                        {roleMapKeys.map((roleId) => {
                            return (
                                <Grid
                                    item
                                    xs={'auto'}
                                    style={{
                                        padding: '6px 20px',
                                        borderRadius: '20px',
                                        backgroundColor: props.recordListRoleFilters?.includes(roleId) ? theme.palette.primary.main : '#D8D8D8',
                                        color: props.recordListRoleFilters?.includes(roleId) ? 'white' : 'rgba(0, 0, 0, 0.87)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        border: 'solid 1px lightgrey',
                                        textTransform: 'capitalize',
                                    }}
                                    key={roleId}
                                    onClick={() => handleRoleFilterSelect(roleId)}
                                >
                                    <Typography>
                                        {roleMap[roleId].name}
                                        ({props?.numberOfTourUsers[roleId] ? props?.numberOfTourUsers[roleId] : 0})
                                    </Typography>
                                </Grid>
                            );
                        })}
                    </Grid>
                )} */}
        </Grid>
    );
};

export default UserListToolbar;
